/**
* Feature Card JS
* -----------------------------------------------------------------------------
*
* All the JS for the Feature Card component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'feature-card',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      function clearTooltips() {
        $( '.feature-card' ).each( function() {
          $( this ).next().removeClass( 'is-open' );
          $( this ).removeClass( 'is-open' );
        } );
      }
      $( document ).on( 'click', function( e ) {
        if ( !e.target.classList.contains( 'feature-card' ) ) {
          clearTooltips();
        }
      } );
      $( document ).on( 'click', '.feature-card:not(.is-open)', function( e ) {
        clearTooltips();
        $( e.target ).next().toggleClass( 'is-open' );
        $( e.target ).toggleClass( 'is-open' );
      } );
      $( document ).on( 'click', '.feature-card.is-open', function( e ) {
        $( e.target ).next().removeClass( 'is-open' );
        $( e.target ).removeClass( 'is-open' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'feature-card', COMPONENT );
} )( app );
